export const overrideMarks: string[] = ['backgroundColor'];

export const DEFAULT_COLOR: {
	color: string;
	label: string;
} = {
	// TODO: DSP-4137 - Remove usage of hardcoded color
	/* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */
	color: '#172b4d',
	label: 'Dark gray',
};
